Librarian.PageBuilder = {
    styleEl: null,
    styleSheetEl: null,
    editLayoutTemplate: null,

    initialize: function () {
        var self = this;

        this.styleSheetEl = new Element("link", {
            id: "PageBuilderStyleSheet",
            rel: "stylesheet",
            type: "text/css"
        }).inject(document.head);

        this.styleEl = new Element("style", { id: "PageBuilderStyles" }).inject(document.head);

        var defaultFile = this.currentLayout = Librarian.pagebuilder.defaultFileName;
        var files = Librarian.pagebuilder.files || [defaultFile];

        files.forEach(function (file) {
            self.loadLayout(file);
        });

        var templateFiles = Librarian.pagebuilder.templates;

        if (templateFiles) {
            templateFiles.forEach(function (file) {
                self.loadLayout(file);
            });
        }

        this.editLayoutTemplate = Handlebars.compile(this.htmlTemplates.editLayout);
    },

    layouts: {},
    currentLayout: null,
    currentPageLayout: null,

    loadLayout: function (filename) {
        var self = this;

        var request = this.getLayout(filename, function (response) {
            var layout = self.onLoadLayout(response.Text, filename);
            self.layouts[filename] = layout;
        }, function () {
            self.layouts[filename] = false;
        });

        // Save request as placeholder until file is loaded
        this.layouts[filename] = request;

        return request;
    },

    getLayout: function (filename, onSuccess, onFailure) {
        var request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getslidetext") + "&out=ujson&snum=1&ignoreerror=true&fname=" + encodeURIComponent(filename),
            method: "get",
            onSuccess: function (response) {
                if (typeOf(onSuccess) === "function") {
                    onSuccess(response);
                }
            },
            onError: function () {
                if (typeOf(onFailure) === "function") {
                    onFailure();
                }

                Librarian.Utils.log("PageBuilder error: could not find " + filename + " in SystemFiles directory.");
            }
        }).send();

        return request;
    },

    onLoadLayout: function (response, filename) {
        if (this.isJson(response))
            return this.parseJsonResponse(response, filename);
        else
            return this.parseXmlResponse(response, filename);
    },

    isJson: function (response) {
        return response.trim().startsWith('{');
    },

    parseJsonResponse: function (response, filename) {
        // For now, assume json layout will be handled in Apps
        var layout = {
            version: "apps",
            filename: filename
        };

        return layout;
    },

    parseXmlResponse: function (response, filename) {
        var layoutXml = new DOMParser().parseFromString(response, 'text/xml');
        var layoutJson = Librarian.Utils.xmlToJson(layoutXml.documentElement);

        var version = parseInt(layoutJson._attributes && layoutJson._attributes.version) || 1;

        try {
            var layout;

            switch (version) {
                case 1:
                    layout = this.parseLayout_v1(layoutJson);
                    break;
                case 2:
                    layout = this.parseLayout_v2_xml(layoutXml, filename);
                    break;
                case 3:
                    layout = this.parseLayout_v3(layoutXml, filename);
                    break;
                default:
                    throw "Invalid layout version: " + version;
            }

            if (layout) {
                layout.version = version;
                layout.filename = filename;
                return layout;
            }
        }
        catch (error) {
            console.error(error);
        }

        // Layout failed to load
        return false;
    },

    setCurrentLayout: function (filename) {
        this.currentLayout = filename;
    },

    buildPage: function (filename, customRenderFn) {
        filename = filename || this.currentLayout;

        var self = this;

        var layout = this.layouts[filename];

        if (layout == false) {
            // This layout failed, so don't try to load it again
            return;
        }
        else if (layout == null) {
            // Returns request object
            layout = this.loadLayout(filename);
        }

        if (layout instanceof Request) {
            // This request is still loading, so try again when it finishes
            layout.addEvent("success", function () {
                self.buildPage(filename, customRenderFn);
            });

            return;
        }

        this.renderPage(layout, customRenderFn);
    },

    renderPage: function (layout, customRenderFn) {
        switch (layout.version) {
            case 1:
                this.renderPage_v1(layout, customRenderFn);
                break;
            case 2:
                this.renderPage_v2(layout);
                break;
            case 3:
                this.renderPage_v3(layout);
                break;
            case "apps":
                this.renderPage_apps(layout);
                break;
        }
    },

    // #region Version 1 - Pure grid

    parseLayout_v1: function (layoutJson) {
        var self = this;

        var enableColors = (layoutJson.EnableColors || "").toLowerCase() === "true";
        var templateName = layoutJson.Template;
        var modules = [];
        var colors = [];

        var layoutModules = Array.from(layoutJson.Module);
        layoutModules.forEach(function (layoutModule, index) {
            var type = layoutModule.Type;

            var module = Object.clone(self.defaultModules[type]);
            if (!module) {
                console.warn("Module not defined: " + type);
                modules[index] = {};
                return;
            }

            var rowSpan = layoutModule.RowSpan;
            if (rowSpan)
                module.rowSpan = rowSpan;

            var colSpan = layoutModule.ColSpan;
            if (colSpan)
                module.colSpan = colSpan;

            var options = layoutModule.Options;
            if (options) {
                Object.forEach(options, function (value, key) {
                    // value must be either number or string
                    var numValue = Number(value);
                    if (!isNaN(numValue)) {
                        module.options[key] = numValue;
                    }
                    else {
                        module.options[key] = value;
                    }
                });
            }

            if (enableColors) {
                var color = layoutModule.Color;
                var hoverColor = layoutModule.HoverColor;

                var colorData = {
                    type: module.options.id,
                    color: color,
                    hoverColor: hoverColor
                };

                colors.push(colorData);
            }

            modules[index] = module;
        });

        return {
            templateName: templateName,
            modules: modules,
            colors: colors
        }
    },

    renderPage_v1: function (layout, customRenderFn) {
        var templateName = layout.templateName,
            modules = layout.modules,
            colors = layout.colors,
            self = this;

        var template = this.templates[templateName];
        if (!template)
            return;

        this.clearStyles();
        this.setStyleSheet("PageBuilder");
        this.setColors(colors);

        if (template.width)
            self.setStyles("#homepage", "width: " + template.width + "px");

        // Wait for styles to be applied
        setTimeout(function () {
            var pageModules = template.getTemplate(modules);

            if (typeof customRenderFn == "function")
                pageModules = customRenderFn(pageModules);

            var moduleLoader = Library.getModuleLoader();
            moduleLoader.loadModules(pageModules);
        }.bind(this), 1);
    },

    // #endregion

    // #region Version 2 - Table

    parseLayout_v2_json: function (layoutJson) {
        var self = this;
        var layout = {
            options: layoutJson.Options,
            rows: []
        };

        var rows = Array.from(layoutJson.Row);
        rows.forEach(function (row) {
            var rowInfo = {
                modules: []
            }

            Object.merge(rowInfo, row._attributes);

            var modules = Array.from(row.Module);
            modules.forEach(function (module) {
                var type = module.Type;

                var moduleInfo = Object.clone(self.defaultModules[type]);
                moduleInfo.id = module.Id;
                moduleInfo.options = module.Options;

                Object.merge(moduleInfo, module._attributes);

                rowInfo.modules.push(moduleInfo);
            });

            layout.rows.push(rowInfo);
        });

        return layout;
    },

    parseLayout_v2_xml: function (layoutXml, filename) {
        var self = this;

        var optionsNode = this.getElementByTagName(layoutXml, "Options"),
            options = Librarian.Utils.xmlToJson(optionsNode);

        var layout = {
            xmlDoc: layoutXml,
            options: options,
            rows: [],
            moduleNodes: []
        };

        var rowNodes = this.getElementsByTagName(layoutXml, "Row");
        rowNodes.forEach(function (rowNode) {
            var rowInfo = {
                modules: []
            };

            var attributes = self.getElementAttributes(rowNode);
            Object.merge(rowInfo, attributes);

            var moduleNodes = self.getElementsByTagName(rowNode, "Module");
            moduleNodes.forEach(function (moduleNode) {
                var nodeCount = layout.moduleNodes.push(moduleNode),
                    module = Librarian.Utils.xmlToJson(moduleNode),
                    type = module.Type;

                var moduleInfo = Object.clone(self.defaultModules[type]);
                moduleInfo.id = module.Id;
                moduleInfo.options = module.Options;
                moduleInfo.filename = filename;
                moduleInfo.nodeIndex = nodeCount - 1;

                Object.merge(moduleInfo, module._attributes);

                rowInfo.modules.push(moduleInfo);
            });

            layout.rows.push(rowInfo);
        });

        return layout;
    },

    renderPage_v2: function (layout) {
        var self = this;
        var options = layout.options;

        this.clearStyles();
        this.setStyleSheet("PageBuilderV2");

        var moduleLoader = new Librarian.ModuleLoader2(options);
        moduleLoader.eventHandler.addEvent("updateModule", this.onUpdateModule.bind(this));
        moduleLoader.eventHandler.addEvent("pageRendered", function () {
            if (Librarian.Utils.isUserMemberOfGroup("Administrators")) {
                self.renderTemplateSelection(layout.filename);
            }
        });
        moduleLoader.load(layout);
    },

    // #endregion

    // #region Version 3 - Flexbox

    parseLayout_v3: function (layoutXml, filename) {
        var self = this;

        var optionsNode = this.getElementByTagName(layoutXml, "Options"),
            options = Librarian.Utils.xmlToJson(optionsNode);

        var layout = {
            xmlDoc: layoutXml,
            options: options,
            sections: [],
            moduleNodes: []
        };

        var sectionNodes = this.getElementsByTagName(layoutXml, "Section");
        sectionNodes.forEach(function (sectionNode) {
            var sectionInfo = self.parseSection_v3(sectionNode, filename);

            layout.sections.push(sectionInfo);
        });

        return layout;
    },

    parseSection_v3: function (sectionNode, filename) {
        var self = this;

        var sectionInfo = {
            columns: []
        };

        var attributes = self.getElementAttributes(sectionNode);
        Object.merge(sectionInfo, attributes);

        var columnNodes = this.getElementsByTagName(sectionNode, "Column");
        columnNodes.forEach(function (columnNode) {
            var columnInfo = self.parseColumn_v3(columnNode, filename);

            sectionInfo.columns.push(columnInfo);
        });

        return sectionInfo;
    },

    parseColumn_v3: function (columnNode, filename) {
        var self = this;

        var columnInfo = {
            modules: []
        };

        var attributes = self.getElementAttributes(columnNode);
        Object.merge(columnInfo, attributes);

        var moduleNodes = self.getElementsByTagName(columnNode, "Module");
        moduleNodes.forEach(function (moduleNode) {
            var moduleInfo = self.parseModule_v3(moduleNode, filename);

            columnInfo.modules.push(moduleInfo);
        });

        return columnInfo;
    },

    parseModule_v3: function (moduleNode, filename) {
        var module = Librarian.Utils.xmlToJson(moduleNode),
            type = module.Type;

        var moduleInfo = Object.clone(this.defaultModules[type]);
        moduleInfo.id = module.Id;
        moduleInfo.options = module.Options;
        moduleInfo.filename = filename;

        Object.merge(moduleInfo, module._attributes);

        return moduleInfo;
    },

    renderPage_v3: function (layout) {
        var options = layout.options;

        this.clearStyles();
        this.setStyleSheet("PageBuilderV3");

        var moduleLoader = new Librarian.ModuleLoader3(options);
        //moduleLoader.eventHandler.addEvent("updateModule", this.onUpdateModule.bind(this));

        moduleLoader.load(layout);
    },

    // #endregion

    // #region Render in Apps

    renderPage_apps: function (layout) {
        this.clearStyles();
        this.setStyleSheet("PageBuilderApps");

        var homepage = $("homepage");
        homepage.empty();

        var wrapper = new Element("div").injectInside(homepage);

        var pageOptions = {
            page: "Custom",
            filename: layout.filename,
            fileId: layout.fileId
        };

        var iframe = new Librarian.Modules.iFrame({
            type: "pages",
            args: pageOptions
        }, wrapper);

        iframe.load();
    },

    // #endregion

    // #region Update and save

    onUpdateModule: function (module, type, data) {
        var moduleInfo = module.moduleInfo;
        if (!moduleInfo || !moduleInfo.filename)
            return;

        var layout = this.layouts[moduleInfo.filename];
        if (!layout)
            return;

        var moduleNode = layout.moduleNodes[moduleInfo.nodeIndex];
        if (!moduleNode)
            return;

        var xmlDoc = layout.xmlDoc;

        switch (type) {
            case "HTML":
                this.onUpdateHtmlModule(xmlDoc, moduleNode, data);
                break;
            default:
                return;
        }

        var xml = Librarian.Utils.getXMLText(xmlDoc);

        this.saveLayout(moduleInfo.filename, xml);
    },

    onUpdateHtmlModule: function (xmlDoc, moduleNode, data) {
        var titleNode = this.getElementByTagName(moduleNode, "title");
        if (titleNode) {
            titleNode.textContent = "";
            var titleCDATA = xmlDoc.createCDATASection(data.title);
            titleNode.appendChild(titleCDATA);
        }

        var htmlNode = this.getElementByTagName(moduleNode, "html");
        if (htmlNode) {
            htmlNode.textContent = "";
            var htmlCDATA = xmlDoc.createCDATASection(data.html);
            htmlNode.appendChild(htmlCDATA);
        }
    },

    saveLayout: function (filename, xml) {
        var blob = new Blob([xml]);
        blob.name = filename;

        // Get CatID
        var url = Librarian.path.getMethodUrl("getcidff") + "&out=cjson&fname=" + encodeURIComponent(filename);

        var request = new Librarian.Request.JSON({
            url: url,
            onSuccess: function (catId) {
                this.uploadLayout(blob, catId);
            }.bind(this),
            onFailure: Librarian.Utils.onFailure
        });

        request.send();
    },

    uploadLayout: function (blob, catId) {
        var notification = Librarian.Utils.notification("Saving Page...", false);

        var uploader = new Librarian.Html5Uploader({
            importOptions: {
                catId: catId,
                publish: true
            },
            waitForComplete: true,
            onComplete: function () {
                notification.close();
                Librarian.Utils.notification("Page saved");
            }.bind(this)
        });

        uploader.uploadFile(blob);
    },

    // #endregion

    // #region XML Parsing

    getElementsByTagName: function (parentNode, tagName) {
        var nodes = parentNode.getElementsByTagName(tagName);

        return Array.from(nodes);
    },

    getElementByTagName: function (parentNode, tagName) {
        var nodes = this.getElementsByTagName(parentNode, tagName);

        return nodes.length > 0 ? nodes[0] : null;
    },

    getElementAttributes: function (node) {
        var attributes = {};

        if (node.attributes.length > 0) {
            for (var j = 0; j < node.attributes.length; j++) {
                var attribute = node.attributes.item(j);
                attributes[attribute.nodeName] = attribute.nodeValue;
            }
        }

        return attributes;
    },

    // #endregion

    setStyleSheet: function (fileName) {
        var href = Librarian.path.getLayoutsPath() + "/core/pagebuilder/css/" + fileName + ".css?" + Librarian.buildVersion;

        this.styleSheetEl.set("href", href);
        this.styleSheetEl.disabled = false;
    },

    setColors: function (moduleColors) {
        var self = this;

        moduleColors.forEach(function (module) {
            var selector = "#module_" + module.type + "_wrapper";

            if (module.color)
                self.setStyles(selector, "background-color: " + module.color + " !important;");

            if (module.hoverColor)
                self.setStyles(selector + ":hover", "background-color: " + module.hoverColor + " !important;");
        });
    },

    setStyles: function (selector, styles) {
        styles = Array.from(styles).join('; ');
        styles = selector + "{ " + styles + " }\n";

        this.styleEl.appendText(styles);
    },

    clearStyles: function () {
        this.styleEl.empty();
    },

    removeCSS: function () {
        this.styleSheetEl.disabled = true;
        this.clearStyles();
    },

    renderTemplateSelection: function (currentTemplate) {
        var templateFiles = Librarian.pagebuilder.templates;
        if (templateFiles == null || templateFiles.length == 0) {
            return;
        }

        var self = this;
        var homepageEl = $("homepage");

        var templateContEl = new Element("div");
        homepageEl.grab(templateContEl, "top");

        var editLayoutHtml = this.editLayoutTemplate();
        templateContEl.set("html", editLayoutHtml);

        var linklEl = templateContEl.getElement(".edit-layout");
        var menuEl = templateContEl.getElement(".edit-layout-layouts");
        Librarian.Utils.bindSDDMMenu(linklEl, menuEl);

        Array.each(templateFiles, function (template, index) {
            var id = "template-outline-" + index;
            var templateEl = new Element("span", {
                "class": "template-outline",
                "id": id
            });
            menuEl.grab(templateEl);

            var layout = self.layouts[template];
            var options = Object.merge({}, layout.options, {
                container: id,
                moduleHeight: 20,
                moduleWidth: 20
            });
            var moduleLoader = new Librarian.ModuleLoader2(options);
            moduleLoader.load(layout);

            templateEl.addOnClick(function () {
                self.switchTemplate(currentTemplate, template);
            });
        });
    },

    switchTemplate: function (currentTemplateName, templateName) {
        var self = this;

        var onGetLayout = function (destinationXml) {
            var layout = self.swapModules(currentTemplateName, destinationXml);
            self.renderPage(layout, currentTemplateName);
        }

        var layout = this.layouts[templateName];
        if (layout != null) {
            onGetLayout(layout.xmlDoc);
        } else {
            this.getLayout(templateName, function (response) {
                var destinationXml = new DOMParser().parseFromString(response.Text, 'text/xml');
                onGetLayout(destinationXml);
            });
        }
    },

    swapModules: function (currentTemplateName, newTemplate) {
        var self = this;
        var oldTemplate = this.layouts[currentTemplateName].xmlDoc;
        var originalModules = oldTemplate.getElementsByTagName("Module");

        // Clone Template
        newTemplate = Librarian.Utils.cloneXMLDoc(newTemplate);

        var destinationModules = newTemplate.getElementsByTagName("Module");
        // Save original template
        this.layouts[currentTemplateName].originalXmlDoc = oldTemplate;

        // Swap out modules from the current template to the new template
        Array.each(destinationModules, function (module, index) {
            if (originalModules[index] != null) {
                self.replaceChildren(originalModules[index], module);
            }
        });

        var newTemplateXml = new XMLSerializer().serializeToString(newTemplate);
        var layout = this.onLoadLayout(newTemplateXml, currentTemplateName);
        this.layouts[currentTemplateName] = layout;

        return layout;
    },

    replaceChildren: function (sourceEl, destinationEl) {
        // Clear all destination children
        while (destinationEl.childNodes.length > 0) {
            destinationEl.removeChild(destinationEl.childNodes[0]);
        }

        // Append source children
        for (var i = 0, len = sourceEl.childNodes.length; i < len; i++) {
            var newNode = sourceEl.childNodes[i].cloneNode(true);
            destinationEl.appendChild(newNode);
        }
    }
};

Librarian.PageBuilder.htmlTemplates = {
    editLayout: "\
    <ul class='edit-layout-cont sddm'> \
        <li>\
            <a href='javascript:void(0)' class='edit-layout' >\
                <span>Edit Layout</span>\
            </a> \
            <div class='edit-layout-layouts'> \
            </div>\
        </li>\
    </ul> \
    "
}

window.addEvent("initComplete", function () {
    Librarian.PageBuilder.initialize();
});